/** Runtime configuration, loaded from /config.json (written at deploy time). */
export type AdminConfig = {
  apiBaseUrl: string;
  /** Origin serving public media (`<mediaBaseUrl>/web/...`), i.e. the public site. Empty for none. */
  mediaBaseUrl: string;
  auth:
    | {
        mode: "cognito";
        /** https://cognito-idp.<region>.amazonaws.com/<userPoolId> */
        authority: string;
        clientId: string;
        /** Hosted UI base URL, e.g. https://<prefix>.auth.<region>.amazoncognito.com */
        domain: string;
      }
    /** Local development only: served by the Vite dev server, never deployed. */
    | { mode: "none" };
};

export async function loadConfig(): Promise<AdminConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`config.json: HTTP ${res.status}`);
  const raw = (await res.json()) as Partial<AdminConfig>;
  if (!raw.auth) throw new Error("config.json: missing auth");
  return { apiBaseUrl: raw.apiBaseUrl ?? "/api", mediaBaseUrl: (raw.mediaBaseUrl ?? "").replace(/\/+$/, ""), auth: raw.auth };
}
